import type { Benefit, NavItem } from "@/types";

export const topBarMessages: string[] = [
  "Atendimento personalizado pelo WhatsApp",
  "Escolha suas peças e finalize com facilidade",
  "Entrega e retirada combinada no atendimento",
  "Moda feminina para todos os seus momentos",
];

export const mainNav: NavItem[] = [
  { label: "Novidades", href: "/novidades" },
  { label: "Blusas", href: "/categoria/blusas" },
  { label: "Calças", href: "/categoria/calcas" },
  { label: "Vestidos", href: "/categoria/vestidos" },
  { label: "Macacões", href: "/categoria/macacoes" },
  { label: "Bermudas", href: "/categoria/bermudas" },
  { label: "Conjuntos", href: "/categoria/conjuntos" },
  { label: "Saias", href: "/categoria/saias" },
];

export const benefits: Benefit[] = [
  {
    id: "atendimento",
    icon: "ri-heart-3-line",
    title: "Atendimento com carinho",
    description: "Cada dúvida é respondida com atenção e cuidado, do primeiro contato à entrega.",
  },
  {
    id: "whatsapp",
    icon: "ri-whatsapp-line",
    title: "Compra facilitada pelo WhatsApp",
    description: "Escolha suas peças com tranquilidade e finalize tudo em uma conversa simples.",
  },
  {
    id: "entrega",
    icon: "ri-truck-line",
    title: "Entrega e retirada combinadas",
    description: "Você escolhe o melhor jeito de receber, combinado direto no atendimento.",
  },
  {
    id: "troca",
    icon: "ri-arrow-left-right-line",
    title: "Troca orientada pela equipe",
    description: "Precisa ajustar algo? A gente acompanha você em cada passo da troca.",
  },
];

export const footerCategories: NavItem[] = [
  { label: "Blusas", href: "/categoria/blusas" },
  { label: "Calças", href: "/categoria/calcas" },
  { label: "Vestidos", href: "/categoria/vestidos" },
  { label: "Macacões", href: "/categoria/macacoes" },
  { label: "Bermudas", href: "/categoria/bermudas" },
  { label: "Conjuntos", href: "/categoria/conjuntos" },
  { label: "Saias", href: "/categoria/saias" },
  { label: "Novidades", href: "/novidades" },
];

export const WHATSAPP_NUMBER = "5562998023960";
export const WHATSAPP_ORDER_BASE = `https://wa.me/${WHATSAPP_NUMBER}`;
export const WHATSAPP_URL = "https://wa.me/message/6X77HRWZGKPQH1";
export const INSTAGRAM_URL = "https://www.instagram.com/vellora__studio/";
export const VELLORA_URL = "https://vellorastudio.suapagina.net.br/";